<template>
  <b-overlay :show="tableLoading" rounded="sm">
    <b-modal id="order-template-modal" @ok="bulkStatement" header-class="p-0"
    footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
    <template #modal-title>
        <div class="title-block text-center p-2">{{ $translate('export_statement') }}</div>
        <div class="close-btn" @click="cancel()">x</div>
    </template>
    <form class="my-3 py-3" @submit.stop.prevent="bulkStatement">

      <b-row>
          <b-col cols="12" class="mb-3">
              <label><strong>{{ $translate('select_option') }}</strong></label>
          </b-col>
          <b-col cols="auto" class="mb-3">
              <b-form-radio
                  id="export-pdf"
                  v-model="export_option"
                  name="export_option"
                  value="pdf"
                  class="mx-1"
              >&nbsp;{{$translate('PDF')}}</b-form-radio>
          </b-col>
          <b-col cols="auto" class="mb-3">
              <b-form-radio
               id="export-word"
                  v-model="export_option"
                  name="export_option"
                  value="word"
                  class="mr-2"
              >&nbsp;{{$translate('Word')}}</b-form-radio>
          </b-col>
          <b-col cols="auto" class="mb-3">
            <b-form-radio
                id="export-excel"
                v-model="export_option"
                name="export_option"
                value="excel"
                class="mr-2"
            >&nbsp;{{$translate('Excel')}}</b-form-radio>
        </b-col>
      </b-row>
  
  </form>
  
    <template #modal-footer="{ ok, cancel }">
        <b-button id="export-activity-statement-btn" size="sm" variant="info" @click="ok()">{{ $translate('export') }}</b-button>
        <b-button id="export-activity-statement-cancel-btn" size="sm" variant="info" @click="cancel()">{{ $cancelLabel() }}</b-button>

    </template>
</b-modal>
    <div class="activity-listing">
      <change-orders-driver
        ref="bulkDriverModalRef"
        :orders="selectedOrders"
        @success="bulkDriverSuccess()"
      />
      <ReportsDialog
        :query="reportFilters"
        :report-list="reportList"
        ref="reportsDialog"
        title="Activity Reports"
      />
      <b-col lg="12" md="12" sm="12" xs="12">
        <b-row class="mb-3 customer-search">
          <b-col
            lg="6"
            md="6"
            sm="6"
            xs="12"
            class="search-field mt-0"
            v-if="showCustomer"
          >
            <form class="d-flex align-items-center h-100" action="#">
              <customer-type-ahead v-model="filters.customer_id" />
            </form>
          </b-col>
          <b-col
            :class="{
              'search-field col-lg-6 col-md-6 col-sm-6 col-xs-12 mt-md-0': showCustomer,
              'search-field col-12 mt-md-0': !showCustomer,
            }"
          >
            <form class="d-flex align-items-center" action="#">
              <b-input-group class="p-0 mb-0" style="height: 50px;">
                <template #prepend>
                  <div class="d-flex">
                    <div class="querySelect dd">
                      <b-form-select
                        class="form-control w-100 h-100"
                        id="input-1"
                        v-model="queryOptionsValue"
                        :options="queryOptions"
                        value-field="value"
                        text-field="name"
                        block
                      />
                    </div>
                    <div class="m-1"></div>
                  </div>
                </template>
                <input
                 id="search-activity-criteria"
                  type="text"
                  v-model="query"
                  class="form-control bg-transparent border-0"
                  :placeholder="$translate('search_activity')"
                />
                <div class="input-group-append bg-transparent">
                  <i class="mdi mdi-magnify"></i>
                </div>
              </b-input-group>
            </form>
          </b-col>
        </b-row>
      </b-col>
      <div class="radio-buton mt-2">
        <div
          class="form-group radio-button col-lg-5 col-md-5 ms-md-5 ms-lg-0 me-2"
        >
          <b-col cols="12">
            <order-date-range v-model="dateRangeIdx" class="mb-0" />
          </b-col>
        </div>
        <b-col
          lg="3"
          md="6"
          sm="12"
          cols="12"
          v-if="!isCustom"
          class="date-time"
        >
          <b-row class="px-sm-5 px-0 justify-content-center">
            <b-col>
              <div class="dt me-2">
                <form class="row">
                  <label for="date" class="col-form-label me-2">{{
                    $translate("start_date")
                  }}</label>
                  <div class="input-group date" id="datepicker">
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.due_from"
                      :max="filters.due_to"
                      id="start-date"
                    />
                  </div>
                </form>
              </div>
            </b-col>
            <b-col>
              <div class="dt">
                <form class="row">
                  <label for="date" class="col-form-label me-2">{{
                    $translate("end_date")
                  }}</label>

                  <div class="input-group date" id="datepicker">
                    <input
                      type="date"
                      class="form-control"
                      v-model="filters.due_to"
                      :min="filters.due_from"
                      id="end-date"
                    />
                  </div>
                </form>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          lg="4"
          md="3"
          sm="3"
          class="button-block btn-position"
          :class="{ 'customer-position': showCustomer }"
        >
          <div class="d-flex">
            <b-button id="open-activity-filter"
              class="col-lg-3 col-md-3 col-sm-3 filter-box blue-button me-2 justify-content-center"
              @click="openFilter"
            >
              <span style="white-space: nowrap;">
                {{ $translate("filters") }}
                <b-icon
                  class="ms-1"
                  :icon="`chevron-${shouldShowFilters ? 'up' : 'down'}`"
                ></b-icon>
              </span>
              <!-- <div>Filter</div> -->
            </b-button>
            <div class="col-lg-1 col-md-1 col-sm-1 me-2">
              <button
                id="reset-activity-filter"
                type="button"
                v-b-tooltip.hover
                @click="resetFilters"
                :title="$translate('reset_filters')"
                class="btn blue-button refresh-block"
              >
                <i class="fa fa-refresh" aria-hidden="true"></i>
              </button>
            </div>
            <page-actions
              :buttons-actions="buttonActions"
              class="activity-btn"
              :dropdown-actions="otherActions"
              :dropdown-title="$translate('bulk_actions')"
              control-class="float-right"
              control-size="sm"
            />
          </div>
        </b-col>
      </div>
      <Filters
        class="filter-activity"
        :date-range="dateRangeIdx"
        v-if="shouldShowFilters"
        v-show="shouldShowFilters"
        ref="queryFilter"
        v-model="filters"
        :roles="roles"
        :customerAgents="customerAgents"
        :progressStatuses="progressStatuses"
        :order-types="orderTypes"
        :categories="categories"
        :interactionTypes="interactionTypes"
        :checkoff-types="checkoffTypes"
        :officers="officers"
        :disabled-officers="!hasPermissionView"
      />

      <div id="navbar-animmenu">
        <ul class="show-dropdown main-navbar">
          <div
            class="hori-selector"
            ref="selector"
            :style="{ width: divWidth, left: divLeft }"
          >
            <div class="left"></div>
            <div class="right"></div>
          </div>
          <li
            v-for="item in entityOptions"
            :key="'entity' + item.value"
            :class="{
              active: entityIdx == item.value,
            }"
            @click="changeEntityIdx(item.value)"
          >
            <a href="javascript:void(0);" :id="item.text">
              <i :class="getIcons[item.value]" aria-hidden="true"></i>
              {{ item.text }}
            </a>
          </li>
        </ul>
      </div>

      <div class="open-tab">
        <div class="col-md-12">
          <div class="page-block">
            <strong>
              {{ $translate("page") }}: {{ pagination.page }}
              {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
              {{ pagination.total }}
            </strong>
          </div>
        </div>
        <div class="main-wrapper">
          <div class="responsive-table table-container">
            <b-table
              :items="orders"
              :fields="fields"
              small
              selectable
              @row-selected="onRowSelected"
              ref="selectableTable"
              id="order-table"
              show-empty
              class="sticky-header-table"
            >
              <template #empty>
                <div class="text-center">No Data Available</div>
              </template>
              <template>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <!-- A custom formatted header cell for field 'name' -->
              <template #head(check)>
                <input
                 id="select-order-check-box-all"
                  type="checkbox"
                  class="form-check-input"
                  v-if="orders.length > 0"
                  :checked="orders.length === selectedOrders.length"
                  @change="toggleAllRow()"
                />
              </template>

              <template #cell(check)="{ rowSelected, index }">
                <input
                :id="'select-order-check-box-' + index"
                  type="checkbox"
                  class="form-check-input"
                  :checked="rowSelected"
                  @change="toggleRow(index, rowSelected)"
                />
              </template>

              <template #cell(actions)="{ item }">
                <router-link
                  class="btn btn-pink-button"
                  v-if="hasPermissionView"
                  :to="`/ams/activities/${item.id}`"
                >
                  <img src="@/assets/images/icon/view.svg" />
                </router-link>
              </template>

              <template #cell(id)="{ item }">
                <h6>
                  <b-badge :variant="item | filterStatusVariant">{{
                    filterStatusName(item)
                  }}</b-badge>
                </h6>
              </template>
              <template #cell(reference_no)="{ item }">
                <span class="tooltip-pointer">
                  <span
                    @mouseover="showTooltipRef = item.id"
                    @mouseleave="showTooltipRef = false"
                    v-b-tooltip.hover
                  >
                    {{ item.reference_no }}
                  </span>
                  <span v-if="showTooltipRef_fn(item)">
                    <div
                      v-html="getTooltipContentforReferance(item)"
                      class="reference-tooltip"
                    ></div>
                  </span>
                </span>
              </template>
              <template #cell(customer)="{ item }">
                <span class="tooltip-pointer">
                  <span
                    @mouseover="showTooltip = item.id"
                    @mouseleave="showTooltip = false"
                    v-b-tooltip.hover
                  >
                    {{ item.customer.name }}
                  </span>
                  <span v-if="showTooltip === item.id">
                    <div
                      v-html="getTooltipContent(item)"
                      class="customer-tooltip"
                    ></div>
                  </span>
                </span>
              </template>

              <template #cell(custom_total)="{ value }">
                <span class="pr-2">
                  {{ value | formatPrice }}
                </span>
              </template>

              <template #cell(tasks)="{ item }">
                <p class="task text-center m-0">
                  {{ item.completedTasks }} /
                  {{ item.totalTasks }}
                </p>
              </template>
              <template #cell(description)="{ item }">
                {{ item.description }}
              </template>
            </b-table>
          </div>
        </div>
        <b-row>
          <b-col>
            <b-pagination
              class="justify-content-center mt-4"
              v-model="pagination.page"
              :total-rows="pagination.total"
              :per-page="pagination.pageSize"
              aria-controls="customerTable"
              :prev-text="$translate('previous')"
              :next-text="$translate('next')"
              pills
              align="center"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import dateTimeMixins from "@/mixins/dateTimeMixins";
import CustomerTypeAhead from "@/components/CustomerTypeAhead.vue";
import popupMixins from "@/mixins/popupMixins";
import permissionsMixins from "@/mixins/permissionsMixins";
import Filters from "./QueryFilter.vue";
import moment from "moment";
import _ from "lodash";
import addActivityIcon from "@/assets/images/icon/add.svg";
import dropdownIcon1 from "@/assets/images/icon/i-1.svg";
import dropdownIcon2 from "@/assets/images/icon/i-2.svg";
import dropdownIcon3 from "@/assets/images/icon/i-3.svg";
import dropdownIcon4 from "@/assets/images/icon/i-4.svg";
import dropdownIcon5 from "@/assets/images/icon/i-5.svg";
import dropdownIcon6 from "@/assets/images/icon/i-6.svg";
import dropdownIcon7 from "@/assets/images/icon/i-7.svg";
import ChangeOrdersDriver from "./ChangeOrdersDriver.vue";
import OrderDateRange from "@/components/OrderDateRange.vue";
import PageActions from "@/components/PageActions.vue";
import ReportsDialog from "@/components/ReportsDialog";
import { templates } from "@/exports/jsreport_templates";

const defaultFilters = Object.freeze({
  driver_id: null,
  completion_date_from: null,
  completion_date_to: null,
  checkoff_type_id: null,
  completed: null,
  checkoff_completed: null,
  customer_agent_id: null,
  type: [],
  status: null,
  role_id: null,
  interaction_type_id: null,
  progress_status_value: null,
  request_category_id: null,
  is_updated: null,
  start_date: null,
  end_date: null,
  due_from: moment().add(-60, "days").format("YYYY-MM-DD"),
  due_to: moment().add(60, "days").format("YYYY-MM-DD"),
});

const dashboardOfficerMap = Object.freeze({
  due_from: moment().add(-360, "days").format("YYYY-MM-DD"),
  due_to: moment().add(30, "days").format("YYYY-MM-DD"),
})
const dateRangeEnum = {
  today: 0,
  yesterday: 1,
  custom: 2,
  tomorrow: 3,
  last_week: 4,
  this_month: 5,
};

export default {
  name: "orders-table",
  components: {
    CustomerTypeAhead,
    OrderDateRange,
    // QueryFilter,
    ChangeOrdersDriver,
    PageActions,
    ReportsDialog,
    Filters,
  },
  mixins: [popupMixins, permissionsMixins, dateTimeMixins],
  props: {
    type: {
      type: String,
    },
    title: String,
    importCounter: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showTooltip: false,
      showTooltipRef: false,
      query: "",
      shouldShowFilters: false,
      filters: { ...defaultFilters },
      bulkAction: "none",
      divWidth: "196px",
      divLeft: "187px",

      dateRangeIdx: 2,
      selectedOrders: [],
      csvFields: {
        ID: "id",
        "Reference ID": "reference_id",
        "Customer Name": "customer.name",
      },

      tableLoading: false,
      timer: "",
      queryOptions: [
        { value: "contains", name: this.$translate("contains") },
        { value: "starts_with", name: this.$translate("starts_with") },
        { value: "ends_with", name: this.$translate("ends_with") },
      ],
      queryOptionsValue: "starts_with",
      export_option : "",
      isSticky: false,
      isFirstTrVisible: false,
    };
  
  },

  filters: {
    formatPrice: function (value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },

    filterStatusVariant(item) {
      return item.completed ? "success" : item.released ? "primary" : "danger";
    },
  },

  computed: {
    entityIdx() {
      return this.$store.state.transactionType.entityIdx;
    },
    allowToUpdateOtherOfficers() {
      return !!this.user_permissions.includes(
        "update.activity.assigned.to.others"
      );
    },
    allowToDeleteOtherOfficers() {
      return !!this.user_permissions.includes(
        "delete.activity.assigned.to.others"
      );
    },
    fields() {
      const { displayLocalDate } = this;
      return [
        "check",
        {
          key: "actions",
          label: this.$translate("actions"),
          thStyle: { width: "70px !important"},
        },
        {
          key: "reference_no",
          label: this.$translate("reference_no"),
          class: "fw-bold",
        },
        {
          key: "schedule_at",
          label: this.$translate("due"),
          formatter: (value) => displayLocalDate(value),
          class: "fw-bold",
        },
        {
          key: "completed_at",
          label: this.$translate("completed"),
          formatter: (value) => displayLocalDate(value),
        },
        {
          key: "customer",
          label: this.$translate("customer"),
          formatter: (value) => value.name,
        },
        {
          key: "id",
          label: this.$translate("status"),
        },
        {
          key: "description",
          label: this.$translate("description"),
          thStyle: { width: "14%", whiteSpace: "normal" },
          thClass: "order-table-description",
          tdClass: "order-table-description",
        },
        {
          key: "type",
          label: this.$translate("type"),
          formatter: (value) =>
            value && value.name === "" ? "-" : value && value.name,
        },
        {
          key: "driver",
          label: this.$translate("officer"),
          formatter: (value) => {
            const { first_name, last_name } = value || {};
            return `${first_name || ""} ${last_name || ""}`;
          },
        },
        {
          key: "custom_total",
          label: this.$translate("total"),
          formatter: (value, key, item) => item.grand_total,
            // item.items &&
            // item.items.reduce((_total, item) => {
            //   const cost = item.quantity * item.price;
            //   const tax_cost = (cost * item.tax_rate) / 100;
            //   _total += cost + tax_cost;
            //   return _total;
            // }, 0),
          class: "fw-bold",
        },
        {
          key: "tasks",
          label: this.$translate("tasks"),
        },
      ];
    },
    getIcons() {
      const icons = [
        "fa fa-retweet",
        "far fa-address-book",
        "fa fa-briefcase",
        "far fa-address-book",
      ];
      return icons;
    },
    reportFilters() {
      const { query, filters, entityIdx, entityOptions } = this;
      const entity = entityOptions[entityIdx] && entityOptions[entityIdx].value;
      console.log("report query", { query, entity, filters });
      const _filters = { ...filters };
      const { type } = filters;
      const types = Array.isArray(type) ? type.map((x) => x.id) : [];
      delete _filters.type;
      const compositeQuery = { query, entity, ..._filters, types };
      console.log("report compositeQuery:", compositeQuery, type);
      return compositeQuery;
    },
    reportList() {
      return [
        {
          value: templates.RPT_SVR_DETPDF_TEMPLATE,
          id: "detail_report",
          extension: "pdf",
          name: "Activity Detail Report",
          label: this.$translate("activity_detail_report"),
        },
        {
          value: templates.RPT_SVR_SUMPDF_TEMPLATE,
          id: "summary_report",
          extension: "pdf",
          name: "Activity Summary Report",
          label: this.$translate("activity_summary_report"),
        },

        {
          value: templates.RPT_SVR_ORD_SUMXLS_TEMPLATE,
          id: "activity_summary_report",
          extension: "xlsx",
          name: "Activity Summary Report Excel",
          label: this.$translate("activity_summary_report_excel"),
        },

        {
          value: templates.RPT_SVR_CRMORD_SUMXLS_TEMPLATE,
          id: "crm_activity_summary_report",
          extension: "xlsx",
          name: "CRM Activity Summary Report Excel",
          label: this.$translate("crm_activity_summary_report_excel"),
        },

        {
          value: templates.RPT_SVR_DETXLS_TEMPLATE,
          id: "detail_export",
          extension: "xlsx",
          name: "Activity Detail Report Excel",
          label: this.$translate("activity_detail_report_excel"),
        },

        {
          value: templates.RPT_SVR_PDF_TEMPLATE,
          id: "pdf_service_summary",
          extension: "pdf",
          name: "Billing Summary Report",
          label: this.$translate("billing_summary_report"),
        },

        {
          value: templates.RPT_SVR_SUMXLS_TEMPLATE,
          id: "summary_export",
          extension: "xlsx",
          name: "Billing Summary Report Excel",
          label: this.$translate("billing_summary_report_excel"),
        },

        {
          value: templates.RPT_SVR_OFF_TEMPLATE,
          id: "officer_details",
          extension: "xlsx",
          name: "Officer Summary Report",
          label: this.$translate("officer_summary_report"),
        },

        {
          value: templates.RPT_SVR_SER_DET_TEMPLATE,
          id: "service_billing_pdf",
          extension: "pdf",
          name: "Billing Detailed Report",
          label: this.$translate("billing_detailed_report"),
        },

        {
          value: templates.RPT_SVR_EXC_TEMPLATE,
          id: "service_billing_excel",
          extension: "xlsx",
          name: "Billing Detail Report Excel",
          label: this.$translate("billing_detail_report_excel"),
        },

        {
          value: templates.RPT_SVR_CUST_ORD_TEMPLATE,
          id: "customer_activity_excel",
          extension: "xlsx",
          name: "Activity-Customer Report Excel",
          label: this.$translate("activity_customer_report_excel"),
        },
        /////////////////////////////////////////  RPT_SVR_BULK_STATEMENTS_TEMPLATE
        {
          value: "invoice_statement",
          template_id: templates.RPT_SVR_BULK_STATEMENTS_TEMPLATE,
          id: "invoice_statement",
          extension: "pdf",
          name: "invoice-statement",
          label: this.$translate("bulk_invoice_statements"),
        },
        {
          value: "fulfilment-note-one",
          template_id: templates.RPT_SVR_BULK_STATEMENTS_TEMPLATE,
          id: "fulfilment-note-one",
          extension: "pdf",
          name: "fulfilment-note-one",
          label: this.$translate("bulk_fulfilment_notes_one"),
        },
        {
          value: "fulfilment-note-two",
          template_id: templates.RPT_SVR_BULK_STATEMENTS_TEMPLATE,
          id: "fulfilment-note-two",
          extension: "pdf",
          name: "fulfilment-note-two",
          label: this.$translate("bulk_fulfilment_notes_two"),
        },
      ];
    },
    isCustom() {
      return this.dateRangeIdx !== 2;
    },
    buttonActions() {
      const actions = [];
      console.log(this.hasPermissionCreate, "this.hasPermissionCreate");
      if (this.hasPermissionCreate) {
        actions.push({
          action: () => this.activitySchedule(),
          variant: "info",
          text: this.$translate("view_calendar"),
          size: "lg",
          class: "btn badge blue-button me-2",
        });
        actions.push({
          action: () => this.createNewOrder(),
          icon: addActivityIcon,
          class: "btn badge blue-button btn-icon-text me-2",
          text: this.$translate("new"),
        });
      }
      return actions;
    },
    otherActions() {
      const actions = [];
      actions.push({
        action: () => this.showReportsDialog(),
        icon: dropdownIcon1,
        text: this.$translate("reports"),
      });
      if (this.hasPermissionCreate) {
        actions.push({
          action: () => this.importOrders(),
          icon: dropdownIcon2,
          text: this.$translate("import_activities"),
        });

        actions.push({
          action: () => this.thirdPartySync(),
          icon: dropdownIcon2,
          text: this.$translate("import_from_third_party_app"),
        });
      }

      //bulk actions
      const anyDisabled = !(
        this.selectedOrders.length > 0 &&
        (this.hasPermissionUpdate || this.hasPermissionDelete)
      );
      const updateDisabled = !(
        this.selectedOrders.length > 0 && this.hasPermissionUpdate
      );
      const deleteDisabled = !(
        this.selectedOrders.length > 0 && this.hasPermissionDelete
      );
      const setDriverDisabled = !this.allowToUpdateOtherOfficers;
      const setDeleteDisabled = !this.allowToDeleteOtherOfficers;
      actions.push({
        divider: true,
        text: this.$translate("bulk_actions"),
        disabled: anyDisabled,
      });

      actions.push(
        {
          action: () => this.bulkSetDriver(),
          icon: dropdownIcon3,
          text: this.$translate("set_officer"),
          disabled: updateDisabled || setDriverDisabled,
        },
        {
          action: () => this.bulkSetIncomplete(),
          icon: dropdownIcon4,
          text: this.$translate("mark_as_incomplete"),
          disabled: updateDisabled || !this.allowToUpdateOtherOfficers,
        },
        {
          action: () => this.bulkSetcomplete(),
          icon: dropdownIcon5,
          text: this.$translate("mark_as_complete"),
          disabled: updateDisabled || !this.allowToUpdateOtherOfficers,
        },
        {
          action: () => this.bulkRelease(),
          icon: dropdownIcon6,
          text: this.$translate("release_activities"),
          disabled: updateDisabled || !this.allowToUpdateOtherOfficers,
        },
        {
          action: () => this.openModal(),
          icon: dropdownIcon2,
          text: this.$translate("activity_statement"),
          disabled: updateDisabled ,
        }
      );

      actions.push({
        action: () => this.bulkDelete(),
        icon: dropdownIcon7,
        text: this.$deleteLabel(),
        disabled: deleteDisabled || setDeleteDisabled,
      });

      return actions;
    },

    showCustomer() {
      return (
        this.fields.some((x) => x.key == "customer") ||
        this.entityIdx === this.getEntityIdx("Customer") ||
        this.entityIdx === this.getEntityIdx("Vendor")
      );
    },
    efields() {
      const _fields = {
        ID: "id",
        "Ref No": "reference_no",
        "Created By": "created_by.first_name",
        "Activity Type": "type.name",
        Customer: "customer.name",
        Tax: "tax",
        "Total Price": "total_price",
        "Customer Signature": {
          field: "signature",
          callback: (value) => (value === 1 ? "YES" : "NO"),
        },
      };
      if (
        this.entityIdx == this.getEntityIdx("Customer") ||
        this.entityIdx == this.getEntityIdx("Vendor")
      )
        return _fields;
      delete _fields.Customer;
      delete _fields["Customer Signature"];

      return _fields;
    },
    entityOptions() {
      return this.$store.getters["transactionType/entityOptions"];
    },

    extended_order_items() {
      return this.orders.reduce((_items, _order) => {
        _items = [..._items, ..._order.items];
        _items = _items.map((x) => {
          x.order = _order;
          x.total_price = x.quantity * x.price;
          x.tax = (x.total_price * x.tax_rate) / 100;
          return x;
        });
        return _items;
      }, []);
    },

    pageCount() {
      return Math.ceil(this.pagination.total / this.pagination.pageSize);
    },
    orderTypes() {
      return this.$store.getters["orderType/activityTypesByPermission"];
    },

    orders() {
      const orders = this.$store.state.orders.items || [];
      return orders.map((x) => {
        x.driver = x.driver || {};
        x.customer = x.customer || {};
        x.warehouse = x.warehouse || {};
        return x;
      });
    },
    pagination() {
      return this.$store.state.orders.pagination || { page: 1 };
    },
    dateObject() {
      return {
        today: {
          due_from: moment().format("YYYY-MM-DD"),
          due_to: moment().format("YYYY-MM-DD"),
        },
        tomorrow: {
          due_from: moment().add(1, "day").format("YYYY-MM-DD"),
          due_to: moment().add(1, "day").format("YYYY-MM-DD"),
        },
        last_week: {
          due_from: moment()
            .subtract(1, "weeks")
            .startOf("week")
            .format("YYYY-MM-DD"),
          due_to: moment()
            .subtract(1, "weeks")
            .endOf("week")
            .format("YYYY-MM-DD"),
        },
        yesterday: {
          due_from: moment().subtract(1, "days").format("YYYY-MM-DD"),
          due_to: moment().subtract(1, "days").format("YYYY-MM-DD"),
        },
        this_month: {
          due_from: moment().startOf("month").format("YYYY-MM-DD"),
          due_to: moment().endOf("month").format("YYYY-MM-DD"),
        },
        custom: {
          due_from: "2020-01-01",
          due_to: moment().format("YYYY-MM-DD"),
        },
      };
    },
    user() {
      const _user = this.$store.state.user;
      console.log("user-----------", _user);
      return _user;
    },
    officers() {
      return (this.$store.state.orders.drivers || []).map((x) => ({
        id: x.id,
        name: `${x.first_name} ${x.last_name}`.trim(),
      }));
    },
    roles() {
      return this.$store.state.roles.items;
    },
    categories() {
      return this.$store.state.requestCategory.categories;
    },

    interactionTypes() {
      return this.$store.state.interactionType.interaction_types;
    },
    progressStatuses() {
      return this.$store.state.progressStatus.progress_statuses;
    },
    customerAgents() {
      return this.$store.state.customerAgents.customer_agents;
    },
    checkoffTypes() {
      const types = this.$store.state.checkoffTypes.types;
      console.log("types", types);
      return types;
    },
    activityPermissions() {
      const permissions = this.$store.state.activityTypeRoles.permissions || [];
      const typeIds = permissions.map((item) => item.type_id);
      console.log("typeIds", typeIds);
      return typeIds;
    },
  },
  watch: {
    hasPermissionView: function (val) {
      console.log("user-----------", this.user);
      console.log("hasPermissionView--------", val);
    },
    query: _.debounce(function (query) {
      this.$router.push({ query: { query } });
      this.doSearch();
    }, 200),
    entityIdx: function () {
      this.updateEntity();
    },
    "pagination.page": function () {
      this.clearSelected();
      this.doSearch();
    },
    queryOptionsValue: function (val) {
      if (this.query != "") {
        this.$router.push({ queryOptionsValue: { val } });
        this.doSearch();
      }
    },
    entityOptions: {
      handler: function (val) {
        console.log("entityOptions:", val);
      },
      deep: true,
    },
    dateRangeIdx: function (val) {
      switch (val) {
        case dateRangeEnum.today:
          this.$set(this.filters, "due_from", moment().format("YYYY-MM-DD"));
          this.$set(this.filters, "due_to", moment().format("YYYY-MM-DD"));
          break;
        //due_to: moment().endOf('month').format('YYYY-MM-DD'),
        case dateRangeEnum.yesterday:
          this.$set(
            this.filters,
            "due_from",
            moment().subtract(1, "days").format("YYYY-MM-DD")
          );
          this.$set(
            this.filters,
            "due_to",
            moment().subtract(1, "days").format("YYYY-MM-DD")
          );
          break;
        //due_to: moment().endOf('month').format('YYYY-MM-DD'),
        case dateRangeEnum.tomorrow:
          this.$set(
            this.filters,
            "due_from",
            moment().add(1, "days").format("YYYY-MM-DD")
          );
          this.$set(
            this.filters,
            "due_to",
            moment().add(1, "days").format("YYYY-MM-DD")
          );
          break;
        case dateRangeEnum.last_week:
          this.$set(
            this.filters,
            "due_from",
            moment().subtract(1, "weeks").startOf("week").format("YYYY-MM-DD")
          );
          this.$set(
            this.filters,
            "due_to",
            moment().subtract(1, "weeks").endOf("week").format("YYYY-MM-DD")
          );
          break;
        case dateRangeEnum.this_month:
          this.$set(
            this.filters,
            "due_from",
            moment().startOf("month").format("YYYY-MM-DD")
          );
          this.$set(
            this.filters,
            "due_to",
            moment().endOf("month").format("YYYY-MM-DD")
          );
          break;
        default:
          break;
      }
      // this.isCustom()
      this.clearSelected();
    },
    filters: {
      handler: function ({
        checkoff_type_id,
        role_id,
        progress_status_value,
        request_category_id,
        interaction_type_id,
        customer_agent_id,
        due_from,
        due_to,
      }) {
        if (
          due_from === this.dateObject.today.due_from &&
          due_to === this.dateObject.today.due_to
        ) {
          this.dateRangeIdx = 0;
        } else if (
          due_from === this.dateObject.yesterday.due_from &&
          due_to === this.dateObject.yesterday.due_to
        ) {
          this.dateRangeIdx = 1;
        } else if (
          due_from === this.dateObject.tomorrow.due_from &&
          due_to === this.dateObject.tomorrow.due_to
        ) {
          this.dateRangeIdx = 3;
        } else if (
          due_from === this.dateObject.last_week.due_from &&
          due_to === this.dateObject.last_week.due_to
        ) {
          this.dateRangeIdx = 4;
        } else if (
          due_from === this.dateObject.this_month.due_from &&
          due_to === this.dateObject.this_month.due_to
        ) {
          this.dateRangeIdx = 5;
        } else {
          this.dateRangeIdx = 2;
        }
        this.checkCheckoffField(checkoff_type_id);
        this.checkProgressStatusField(progress_status_value);
        this.checkCategoryField(request_category_id);
        this.checkRoleField(role_id);
        this.checkCustomerAgentsField(customer_agent_id);
        this.checkInteractionTypeField(interaction_type_id);
        this.doSearch();
      },
      deep: true,
    },
    importCounter: function () {
      this.doSearch(true);
    },
  },

  async mounted() {
    try {
      // this.setColumnWidths()
      window.addEventListener('scroll', this.handleScrollDebounced);
      window.addEventListener('resize', this.setColumnWidths);
      const { query } = this.$route;
      this.$set(this.filters, "driver_id", parseInt(this.user.id));
      if(this.$store.state.orders.filters && !query.is_from_dashboard){
        for(const key in this.$store.state.orders.filters){

          const value = this.$store.state.orders.filters[key];
          
          if (key == 'type' && value) {
            let filtered_types = this.orderTypes && this.orderTypes.filter(x => value.split(',').some(i => i == x.id))
            this.$set(this.filters, key, filtered_types || [])
            console.log('type=', filtered_types)
          } else {
            this.$set(this.filters, key, value)
          }
        }
      } else if(query.is_from_dashboard) {
        this.$set(this.filters, "driver_id", parseInt(query.driver_id));
        this.$set(this.filters, "due_from", dashboardOfficerMap.due_from);
        this.$set(this.filters, "due_to", dashboardOfficerMap.due_to);
      } else {
        this.$set(this.filters, "driver_id", parseInt(this.user.id));
      }
      this.tableLoading = true;
      let isforcedReload = true;
      this.timer = setInterval(() => {
        this.checkPartnerField(isforcedReload);
      }, this.$activityListRefreshTime);
      await this.$store.dispatch("transactionType/fetchAll");

      //http://localhost:8080/#/orders?page=1&query=&changed=0&driver_id=0&customer_id=0&completed=any&type=any&is_updated=any&due_from=2020-01-01&due_to=2020-09-16

      const { entityOptions } = this;
      console.log(entityOptions, "entityOptions--------------------------");
      const entity = entityOptions[this.entityIdx].value;
      this.filters.entity = this.$route.query.entity || entity;

      console.log(query, "dateRangeIdx query")
      if (query.query) this.query = query.query;
      if (query.changed) this.$set(this.filters, "changed", query.changed);

      // if (query.driver_id || this.filters.driver_id)
      //   this.$set(this.filters, "driver_id", parseInt(query.driver_id || this.filters.driver_id));
      // else if(this.user)
      //   this.$set(this.filters, "driver_id", parseInt(this.user.id));
      if (query.customer_id)
        this.$set(this.filters, "customer_id", parseInt(query.customer_id));

      if (query.completed) this.$set(this.filters, "completed", 1);
      // if (query.type) this.$set(this.filters, "type", query.type);
      if (query.is_updated)
        this.$set(this.filters, "is_updated", query.is_updated);
      if (query.due_from) this.$set(this.filters, "due_from", query.due_from);
      if (query.due_to) this.$set(this.filters, "due_to", query.due_to);

      console.log("user-----------", this.user);
      console.log("hasPermissionView--------", this.hasPermissionView);

      if (!this.hasPermissionView) {
        this.$set(this.filters, "driver_id", this.user.id);
      }
      this.updateEntity();
      this.$store.commit("orders/SET_ORDER", {});
      this.$store.commit("orders/SET_ORDER_ITEMS", []);
    } catch (err) {
      console.log("mounted", err, this.filters);
    } finally {
      this.tableLoading = false;
    }
  },
  methods: {
    changeEntityIdx(idx) {
      this.$store.commit("transactionType/set_entity_index", idx);
    },
    getEntityIdx(text) {
      return (this.entityOptions.find((x) => x.text == text) || {}).value;
    },
    filterStatusName(item) {
      return item.completed
        ? this.$translate("completed")
        : item.released
        ? this.$translate("processing")
        : this.$translate("pending");
    },
    async openFilter() {
      this.shouldShowFilters = !this.shouldShowFilters;
      if (this.shouldShowFilters) {
        this.$store.dispatch("orderType/fetchAll");
        await Promise.all([
          this.$store.dispatch("checkoffTypes/fetchAll"),
          this.$store.dispatch("progressStatus/fetchAll"),
          this.$store.dispatch("roles/fetchAll"),
          this.$store.dispatch("orders/fetchDriversNew"),
          this.$store.dispatch("requestCategory/fetchAll"),
          this.$store.dispatch("customerAgents/fetchAll"),
          this.$store.dispatch("interactionType/fetchAll"),
        ]);
      }
    },
    getTooltipContent(item) {
      const address =
        item.customer &&
        item.customer.location_section &&
        item.customer.location_section.location.address1 !== null
          ? item.customer.location_section.location.address1
          : "N/A";
      const customer_email =
        item.customer.email !== null ? item.customer.email : "N/A";
      const mobile_number =
        item.customer.phone !== null ? item.customer.phone : "N/A";
      const work_number =
        item.customer.work_number !== null ? item.customer.work_number : "N/A";
      const htmlContent = `
        <ul>
          <li>${this.$translate("email")}: ${customer_email}</li>
          <li>${this.$translate("mobile_number")}: ${mobile_number}</li>
          <li>${this.$translate("work_number")}: ${work_number}</li>
          <li>${this.$translate("location")}: ${address}</li>
        </ul>
      `;
      return htmlContent;
    },
    getTooltipContentforReferance(item) {
      try {
        // Dispatch the action and wait for it to complete
        let htmlContent = "";
        if (
          item.activity_link_list &&
          item.activity_link_list.previous_activity
        ) {
          htmlContent += `<span>${this.$translate("previous_activity")}</span>
      <ul class="m-0">
        <li>${item.activity_link_list?.previous_activity.reference_no} </li>
      </ul>
    `;
        }

        if (
          item.activity_link_list &&
          item.activity_link_list.original_activity &&
          item.activity_link_list.original_activity.id != item.id
        ) {
          htmlContent += `<span>${this.$translate("original_activity")}</span>
      <ul class="m-0">
        <li>${item.activity_link_list?.original_activity.reference_no} </li>
      </ul>
    `;
        }
        console.log("html------", htmlContent);
        return htmlContent;
      } catch (error) {
        console.error("Error fetching data:", error);
        return ""; // Return empty string or any default content in case of error
      }
    },

    activitySchedule() {
      this.$router.push("/ams/activity-schedule");
    },

    updateEntity(val) {
      this.$nextTick(() => {
        this.checkPartnerField();
        let activeItem = this.$el.querySelector(".active");
        console.log(activeItem, "::::::::::activeItem");
        console.log(val, "::::::::::::entity value");
        const selector = this.$refs.selector;
        console.log(selector, "::::::::::::selector");
        if (activeItem && selector) {
          const activeItemWidth = activeItem.offsetWidth;
          const activeItemLeft = activeItem.offsetLeft;
          this.divWidth = `${activeItemWidth}px`;
          this.divLeft = `${activeItemLeft}px`;
        }
      });
    },
    showReportsDialog() {
      this.$refs.reportsDialog.show();
    },
    createNewOrder() {
      this.$store.commit("locations/SET_LOCATION", {});
      this.$router.push("/ams/activities/0");
    },
    importOrders() {
      this.$emit("import");
    },
    async thirdPartySync() {
      try {
        // this.tableLoading = true;
        await this.$store.dispatch("synchronizer/runSynchronizer");
        this.doSearch(true);
      } catch (err) {
        console.log("err", err);
      } finally {
        // this.tableLoading = false;
      }
    },

    doPause() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          return resolve();
        });
      });
    },

    async resetFilters() {
      try {
        this.tableLoading = true;

        this.$store.commit("transactionType/set_entity_index");

        await this.doPause();

        let driver_id = this.user.id;
        
        this.query = "";
        this.queryOptionsValue = "starts_with";
        this.filters = { ...defaultFilters, driver_id };
        await this.doSearch(true);
      } catch (err) {
        console.error("resetFilters", err);
      } finally {
        this.tableLoading = false;
      }
    },
    checkPartnerField(isforcedReload = false) {
      const CustomerLabel = "Customer";
      const VendorLabel = "Vendor";

      const { fields, entityOptions } = this;
      if (entityOptions.length == 0) return;

      const partnerField = {
        key: "customer",
        label: this.$translate("customer"),
        formatter: (value) => value.name,
      };
      const addPartnerField = (label) => {
        partnerField.label = label;
        this.fields.splice(5, 0, partnerField);
      };
      const deletePartnerField = (idx) => {
        this.fields.splice(idx, 1);
      };
      const updatePartnerField = (label) => {
        partnerField.label = label;
        this.fields.splice(idx, 1, partnerField);
      };

      const { entityIdx } = this;

      const isCustomerEntity = entityOptions[entityIdx].text == CustomerLabel;

      const isVendorEntity = entityOptions[entityIdx].text == VendorLabel;

      const idx = fields.findIndex((x) => x.key === partnerField.key);
      console.log("watcherEntity idx", idx);

      if (idx == -1) {
        if (isCustomerEntity) addPartnerField(CustomerLabel);
        else if (isVendorEntity) addPartnerField(VendorLabel);
      } else if (isCustomerEntity) {
        updatePartnerField(CustomerLabel);
      } else if (isVendorEntity) {
        updatePartnerField(VendorLabel);
      } else {
        deletePartnerField(idx);
      }
      this.doSearch(isforcedReload);
    },
    checkCheckoffField(checkoff_type_id) {
      const { fields, checkoffTypes } = this;
      console.log("checkoffTypes", checkoffTypes);
      const checkoffType = checkoffTypes.find((x) => x.id === checkoff_type_id);
      const checkoffField = {
        key: "checkoffs",
        label:
          (checkoffType && checkoffType.name) || this.$translate("reviewed"),
        formatter: (value) => {
          const isCompleted =
            (value.find((x) => x.checkoff_type_id == checkoff_type_id) || {})
              .completed == 1;
          return isCompleted ? this.$translate("yes") : this.$translate("no");
        },
      };
      const addCheckoffField = () => this.fields.splice(6, 0, checkoffField);

      const deleteCheckoffField = (idx) => this.fields.splice(idx, 1);

      const updateCheckoffField = (idx) =>
        this.fields.splice(idx, 1, checkoffField);

      const isValid = (_idx) => _idx >= 0;

      const idx = fields.findIndex((x) => x.key === checkoffField.key);

      if (!isValid(idx) && checkoff_type_id) addCheckoffField();
      else if (isValid(idx) && checkoff_type_id) updateCheckoffField(idx);
      else if (!checkoff_type_id && isValid(idx)) deleteCheckoffField(idx);
    },

    checkProgressStatusField(progress_status_value) {
      const { fields } = this;

      const progressStatusField = {
        key: "progress_status_value",
        label: this.$translate("progress_status"),
        formatter: (value, key, item) => item.progress_status.name,
      };
      const addProgressStatusField = () =>
        this.fields.splice(6, 0, progressStatusField);

      const deleteProgressStatusField = (idx) => this.fields.splice(idx, 1);

      const updateProgressStatusField = (idx) =>
        this.fields.splice(idx, 1, progressStatusField);

      const isValid = (_idx) => _idx > 0;

      const idx = fields.findIndex((x) => x.key === progressStatusField.key);

      if (
        (!isValid(idx) && progress_status_value) ||
        (!isValid(idx) && progress_status_value == 0)
      )
        addProgressStatusField();
      else if (isValid(idx) && progress_status_value)
        updateProgressStatusField(idx);
      else if (!progress_status_value && isValid(idx))
        deleteProgressStatusField(idx);
    },
    checkCategoryField(request_category_id) {
      const { fields } = this;

      const CategoryField = {
        key: "request_category_id",
        label: this.$translate("activity_category"),
        formatter: (value, key, item) => {
          return item && item.category && item.category.name;
        },
      };
      const addCategoryField = () => this.fields.splice(6, 0, CategoryField);

      const deleteCategoryField = (idx) => this.fields.splice(idx, 1);

      const updateCategoryField = (idx) =>
        this.fields.splice(idx, 1, CategoryField);

      const isValid = (_idx) => _idx > 0;

      const idx = fields.findIndex((x) => x.key === CategoryField.key);

      if (!isValid(idx) && request_category_id) addCategoryField();
      else if (isValid(idx) && request_category_id) updateCategoryField(idx);
      else if (!request_category_id && isValid(idx)) deleteCategoryField(idx);
    },
    checkRoleField(role_id) {
      const { fields } = this;

      const RoleField = {
        key: "role_id",
        label: this.$translate("role"),
        formatter: (value, key, item) =>
          item.driver.roles &&
          item.driver.roles[0].role &&
          item.driver.roles[0].role.name,
      };
      const addRoleField = () => this.fields.splice(7, 0, RoleField);

      const deleteRoleField = (idx) => this.fields.splice(idx, 1);

      const updateRoleField = (idx) => this.fields.splice(idx, 1, RoleField);

      const isValid = (_idx) => _idx > 0;

      const idx = fields.findIndex((x) => x.key === RoleField.key);

      if (!isValid(idx) && role_id) addRoleField();
      else if (isValid(idx) && role_id) updateRoleField(idx);
      else if (!role_id && isValid(idx)) deleteRoleField(idx);
    },
    checkCustomerAgentsField(customer_agent_id) {
      const { fields } = this;

      const CustomerAgentField = {
        key: "customer_agent_id",
        label: this.$translate("customer_agent"),
        formatter: (value, key, item) =>
          this.customerAgentName(item.customer_agent_id),
      };
      const addCustomerAgentField = () =>
        this.fields.splice(7, 0, CustomerAgentField);

      const deleteCustomerAgentField = (idx) => this.fields.splice(idx, 1);

      const updateCustomerAgentField = (idx) =>
        this.fields.splice(idx, 1, CustomerAgentField);

      const isValid = (_idx) => _idx > 0;

      const idx = fields.findIndex((x) => x.key === CustomerAgentField.key);

      if (!isValid(idx) && customer_agent_id) addCustomerAgentField();
      else if (isValid(idx) && customer_agent_id) updateCustomerAgentField(idx);
      else if (!customer_agent_id && isValid(idx))
        deleteCustomerAgentField(idx);
    },
    checkInteractionTypeField(interaction_type_id) {
      const { fields } = this;
      const InteractionTypeField = {
        key: "interaction_type_id",
        label: this.$translate("interaction_type"),
        formatter: (value, key, item) =>
          this.interactionTypeName(item.interaction_type_id),
      };
      const addInteractionTypeField = () =>
        this.fields.splice(7, 0, InteractionTypeField);

      const deleteInteractionTypeField = (idx) => this.fields.splice(idx, 1);

      const updateInteractionTypeField = (idx) =>
        this.fields.splice(idx, 1, InteractionTypeField);

      const isValid = (idx) => idx > 0;

      const idx = fields.findIndex((x) => x.key === InteractionTypeField.key);

      if (!isValid(idx) && interaction_type_id) addInteractionTypeField();
      else if (isValid(idx) && interaction_type_id)
        updateInteractionTypeField(idx);
      else if (!interaction_type_id && isValid(idx))
        deleteInteractionTypeField(idx);
    },
    interactionTypeName(interaction_type_id) {
      const interactionType = this.interactionTypes.find(
        (x) => x.id === interaction_type_id
      );
      const interactionTypeName = interactionType && interactionType.name;
      return interactionTypeName;
    },
    onRowSelected(items) {
      this.selectedOrders = items;
    },
    selectAllRows() {
      this.$refs.selectableTable && this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable && this.$refs.selectableTable.clearSelected();
    },
    toggleRow(index, rowSelected) {
      // Rows are indexed from 0, so the third row is index 2
      if (rowSelected) this.$refs.selectableTable.unselectRow(index);
      else this.$refs.selectableTable.selectRow(index);
    },

    toggleAllRow() {
      if (this.orders.length === this.selectedOrders.length)
        this.$refs.selectableTable.clearSelected();
      else this.$refs.selectableTable.selectAllRows();
    },
    customerAgentName(agent_id) {
      const customerAgent = this.customerAgents.find((x) => x.id == agent_id);
      return customerAgent.agent_name;
    },

    ////////////////////////////////

    checkKeyType(key) {
      switch (key) {
        case "created_at":
        case "updated_at":
        case "schedule_at":
        case "completed_at":
          return "date";
        case "completed":
        case "completed_by":
          return "bool";
        case "driver_id":
        case "description":
        case "address":
        case "signature":
        case "released":
        case "signee":
        case "reference_no":
        case "total_price":
        default:
          return null;
      }
    },

    bulkSetDriver() {
      this.$refs.bulkDriverModalRef.show();
    },
    bulkDriverSuccess() {
      this.doSearch().then(() => {
        this.clearSelected();
      });
    },

    async bulkRelease() {
      try {
        const title = this.$translate("release_activities_title");
        const message = this.$translate(`release_activities_note`);

        const result = await this.confirmMessage(title, message);
        if (!result) {
          throw new Error("");
        } else {
          this.tableLoading = true;
        }

        const orders = this.selectedOrders.map((x) => x.id);
        console.log("orders--tests", orders);
        await this.$store.dispatch("orders/bulkRelease", { orders });

        this.doToast(
          this.$translate("success"),
          this.$translate("bulk_activity_released"),
          "success"
        );
        this.clearSelected();
        await this.doSearch();
      } catch (error) {
        // this.doToast(
        //   this.$translate("error"),
        //   this.$translate("bulk_activity_released_error"),
        //   "danger"
        // );
        this.doToast(this.$translate("error"), error.message, "danger");
      } finally {
        this.tableLoading = false;
      }
    },
    async openModal(){
      this.$bvModal.show('order-template-modal')
    },
    async bulkStatement(){
      try {
       
        this.tableLoading = true;
        const { export_option } = this;

        const orders = this.selectedOrders.map((x) => x.id);
        console.log("orders--tests", orders);
        await this.$store.dispatch("orders/bulkStatement", { orders , export_option});
        this.clearSelected();
       
      } catch (error) {
        this.doToast(this.$translate("error"), error.message, "danger");
      } finally {
        this.tableLoading = false;
      }
    },

  
    async bulkSetIncomplete() {
      try {
        const title = this.$translate("mark_as_incomplete_title");
        const message = this.$translate(`mark_as_incomplete_note`);

        let result = await this.optionsMessage(title, message);

        console.log("results", result);
        const { confirmed, optionSelected: unrelease } = result || {};

        if (!confirmed) return;
        this.tableLoading = true;
        const orders = this.selectedOrders.map((x) => x.id);
        await this.$store.dispatch("orders/bulkSetIncomplete", {
          orders,
          unrelease,
        });

        this.doToast(
          this.$translate("success"),
          this.$translate("bulk_activity_incomplete"),
          "success"
        );
        this.clearSelected();
        await this.doSearch();
      } catch (err) {
        this.doToast(
          this.$translate("error"),
          this.$translate("bulk_activity_incomplete_error"),
          "danger"
        );
      } finally {
        this.tableLoading = false;
      }
    },
    async bulkSetcomplete() {
      const title = this.$translate("mark_as_complete_title");
      const message = this.$translate(`mark_as_complete_note`);
      const result = await this.confirmMessage(title, message);
      if (!result) return;
      navigator.geolocation.getCurrentPosition(async (p) => {
        try {
          this.tableLoading = true;
          const lat = p.coords.latitude;
          const long = p.coords.longitude;
          const getAddress = await this.$store.dispatch(
            "orders/geocodeStreet",
            {
              lat,
              long,
            }
          );
          const address = {
            lat: p.coords.latitude,
            long: p.coords.longitude,
            signature_address: getAddress?.[0]?.display_name || '',
          };
          const orders = this.selectedOrders.map((x) => x.id);
          await this.$store.dispatch("orders/bulkSetcomplete", {
            orders,
            address,
          });

          this.doToast(
            this.$translate("success"),
            this.$translate("bulk_activity_complete"),
            "success"
          );
          this.clearSelected();
          this.doSearch();
        } catch (error) {
          this.doToast(this.$translate("error"), error.message, "danger");
        } finally {
          this.tableLoading = false;
        }
      });
    },
    async bulkDelete() {
      try {
        const title = this.$translate("delete_activities_title");
        const message = this.$translate(`delete_activities_note`);

        const result = await this.confirmMessage(title, message);
        console.log("result", result);
        if (!result) return false; //throw new Error("");

        this.tableLoading = true;
        await this.$store.dispatch("orders/bulkDelete", {
          orders: this.selectedOrders,
        });

        this.doToast(
          this.$translate("success"),
          this.$translate("bulk_activity_delete"),
          "success"
        );

        await this.doSearch();
      } catch (err) {
        console.error(err);
        this.doToast(
          this.$translate("error"),
          this.$translate("bulk_activity_delete_error"),
          "danger"
        );
      } finally {
        this.clearSelected();
        this.tableLoading = false;
      }
    },

    applyBulkAction() {},

    async doSearch(isforcedReload = false) {
      try {
        this.tableLoading = true;
        await this.doPause();
        let {
          query,
          queryOptionsValue, // activity search type dropdown selection
          filters,
          pagination: { page },
          entityOptions,
          entityIdx,
        } = this;

        page = parseInt(page) || 1;

        if (entityOptions.length == 0) return;
        filters.completed =
          filters.status == 1 && filters.completed == null
            ? 1
            : filters.completed;
        if (filters.status == 2 || filters.status == 3) filters.completed;
        filters.entity = entityOptions[entityIdx].value;

        let type = "";
        if (filters.type && filters.type.length > 0 && Array.isArray(filters.type)) {
          type = filters.type.map((i) => i.id).join(",");
        }

        this.$router.push({
          query: { page, query, ...filters, queryOptionsValue, type },
        });
        await this.$store.dispatch("orders/fetch", {
          query,
          filters: { ...filters, type: type, queryOptionsValue },
          page,
          isforcedReload,
        });
      } catch (err) {
        console.log("search:", err);
      } finally {
        this.tableLoading = false;
        this.setColumnWidths()
      }
    },
    currency(num) {
      return num;
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    showTooltipRef_fn(item) {
      return (
        this.showTooltipRef === item.id &&
        item.activity_link_list &&
        (item.activity_link_list.previous_activity ||
          (item.activity_link_list.original_activity &&
            item.activity_link_list.original_activity.id !== item.id))
      );
    },
    handleScrollDebounced: _.debounce(function() {
      if (this.$refs.selectableTable) {
        const table = this.$refs.selectableTable.$el;
      const thead = table.querySelector('thead');
      const tbody = table.querySelector('tbody');
      const firstTr = tbody.querySelector('tr');

      const rect = thead.getBoundingClientRect();

      if (rect.top < 70 && !this.isSticky) {
        this.setColumnWidths()
        thead.classList.add('sticky');
        this.isSticky = true;
      } else if (window.scrollY <= 70 && this.isSticky) {
        thead.classList.remove('sticky');
        this.isSticky = false;
        this.setColumnWidths()
      }

      if (firstTr && !this.isFirstTrVisible && firstTr.getBoundingClientRect().top > 70) {
        thead.classList.remove('sticky');
        this.isSticky = false;
        this.setColumnWidths()
      }
     }
    
    }, 100),

    setColumnWidths() {
      if (this.$refs.selectableTable) {
          const table = this.$refs.selectableTable.$el;
      const thead = table.querySelector('thead');
      const tbody = table.querySelector('tbody');
      const tbodyFirstRow = tbody.querySelector('tr');

      if (tbodyFirstRow) {
        const ths = thead.querySelectorAll('th');
        const tds = tbodyFirstRow.querySelectorAll('td');

        thead.style.width = `${tbody.offsetWidth}px`

        console.log('width-', thead.offsetWidth, 'width2-',tbody.offsetWidth)

        tds.forEach((td, index) => {
          if (ths[index] && td) {
            td.style.width = `${td.offsetWidth}px`
            ths[index].style.width = `${td.offsetWidth}px`;
          }
        });
      }
      }
    
    }

  },
  beforeDestroy() {
    this.cancelAutoUpdate();
    window.removeEventListener('scroll', this.handleScrollDebounced);
    window.removeEventListener('resize', this.setColumnWidths);
  },
};
// Debounce function to limit the frequency of scroll event handling
</script>

<style>
.table-container {
  position: relative;
}

.sticky {
  position: fixed;
  top: 70px; /* Adjust for the fixed header height */
  background-color: white;
  z-index: 1020;
  display: table;
  /* width: calc(100% - 32px); */
}


.sticky th {
  border-bottom: 1px solid #ebedf2;
}
</style>